let API_URL
let PROJECT
let DEVICE_LOGS_BUCKET
let PULLBACK_VIDEO_BUCKET
let PULLBACK_IMAGE_BUCKET
if (process.env.NODE_ENV === 'local') {
  API_URL = 'http://localhost:5000'
  PROJECT = 'athelas'
  DEVICE_LOGS_BUCKET = 'athelas-device-logs'
} else if (process.env.NODE_ENV === 'staging') {
  API_URL = 'https://staging-api.athelas.com'
  PROJECT = 'athelas-staging'
  DEVICE_LOGS_BUCKET = 'athelas-staging-device-logs'
  PULLBACK_VIDEO_BUCKET = 'athelas-pullback-videos-staging'
  PULLBACK_IMAGE_BUCKET = 'athelas-staging-local-pullback-images'
} else {
  API_URL = 'https://api.athelas.com'
  PROJECT = 'athelas-production'
  DEVICE_LOGS_BUCKET = 'athelas-production-device-logs'
  PULLBACK_VIDEO_BUCKET = 'athelas-pullback-videos'
  PULLBACK_IMAGE_BUCKET = 'local_pullback_images'
}

const SALES_ROLE = 'SALES'

const REQUIRED_TESTS = [
  {
    key: 'communications',
    tests: [
      'test_bluetooth_signalling',
      'test_camera_connected',
      'test_watchdog_running',
    ]
  },
  {
    key: 'linac_movements',
    tests: [
      'test_strip_start_position',
      'test_strip_home_position'
    ]
  }
]

const DEPLOYMENT_STATES = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  MANUFACTURING: 'manufacturing',
  RESEARCH: 'research'
}

const JOB_STATUSES = {
  QUEUED: 'queued',
  IMAGING: 'imaging',
  UPLOADING: 'uploading',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
}

const CANCELLABLE_JOB_STATUSES = [JOB_STATUSES.QUEUED, JOB_STATUSES.IMAGING]

const LOW_QC_LEVEL = 'low'
const NORMAL_QC_LEVEL = 'normal'
const HIGH_QC_LEVEL = 'high'

const QC_LEVELS = [LOW_QC_LEVEL, NORMAL_QC_LEVEL, HIGH_QC_LEVEL]

const FINISHED_JOB_STATUSES = [JOB_STATUSES.COMPLETED, JOB_STATUSES.FAILED, JOB_STATUSES.CANCELLED]

const CALIBRATION_FACTORS = {
  '4x': 0.3423 / 6.65 * 12 / 11.5,
  '10x': 0.3423,
  CONTROL: 0.3423 / 6.65 * 12 / 11.5
}

const STRIP_TYPES = {
  WBC_CONTROL: 'wbc_control',
  WBC_CONTROL_ATH_CHECK: 'wbc_control_ath_check',
  WBC_CONTROL_HIGH: 'wbc_control_high',
  WBC: 'wbc_4x',
  PLATELET: 'platelet',
  PLATELET_CONTROL_FLUID: 'platelet_control_fluid',
  WBC_COUNTROL_AUTO_CHECK_LOW: 'wbc_control_ath_auto_low',
  WBC_COUNTROL_AUTO_CHECK_NORMAL: 'wbc_control_ath_auto_normal',
  WBC_COUNTROL_AUTO_CHECK_HIGH: 'wbc_control_ath_auto_high',
  COMBINED_AUTO_CHECK_LOW: 'auto_low',
  COMBINED_AUTO_CHECK_NORMAL: 'auto_normal',
  COMBINED_AUTO_CHECK_HIGH: 'auto_high',
}

const CONTROL_LEVEL_VALUES = {
  1: {
    'wbc_count': 3.0,
    'neutrophils': 50
  },
  2: {
    'wbc_count': 7.9,
    'neutrophils': 55
  },
  3: {
    'wbc_count': 21.9,
    'neutrophils': 60
  }
}

const NUM_QC_RUNS_PER_LEVEL = 3

const FLAG_MESSAGES = {
  0: 'No flag. Normal result.',
  1: 'Platelet Aggregates detected. Please conduct a manual review.',
  2: 'Abnormal Lymphocytes detected. Please conduct a manual review.',
  5: 'Clotted (fibrins) sample detected. Please conduct a manual review.',
  6: 'Thrombo-. Please conduct a manual review.',
  7: 'Thrombo+. Please conduct a manual review.',
  8: 'Anemia. Please conduct a manual review.',
}

const STORAGE_URL = 'https://console.cloud.google.com/storage/browser/'

export default {
  API_URL,
  PROJECT,
  DEVICE_LOGS_BUCKET,
  PULLBACK_VIDEO_BUCKET,
  PULLBACK_IMAGE_BUCKET,
  REQUIRED_TESTS,
  DEPLOYMENT_STATES,
  CALIBRATION_FACTORS,
  STRIP_TYPES,
  CONTROL_LEVEL_VALUES,
  NUM_QC_RUNS_PER_LEVEL,
  FLAG_MESSAGES,
  JOB_STATUSES,
  FINISHED_JOB_STATUSES,
  LOW_QC_LEVEL,
  NORMAL_QC_LEVEL,
  HIGH_QC_LEVEL,
  QC_LEVELS,
  SALES_ROLE,
  CANCELLABLE_JOB_STATUSES,
  STORAGE_URL,
}



// WEBPACK FOOTER //
// ./src/lib/constants.js